import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  /**
   * Utility method to log messages only in non-production environments
   * @param message The message to log
   * @param data Optional data to include in the log
   * @param logType Type of log: 'log', 'warn', 'error'
   */
  logIfNotProd(
    message: string,
    data?: unknown,
    logType: 'log' | 'warn' | 'error' = 'log',
  ): void {
    if (environment.env !== 'prod' && environment.env !== 'demo') {
      const currentDate = new Date();
      const timestamp = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
      if (data) {
        // eslint-disable-next-line no-console
        console[logType](message, data, timestamp);
      } else {
        // eslint-disable-next-line no-console
        console[logType](message, timestamp);
      }
    }
  }

  /**
   * Utility method for styled console logs (like the colored ones in your code)
   * @param message The message to display
   * @param backgroundColor Background color for the styled log
   * @param textColor Text color for the styled log
   */
  logStyledIfNotProd(
    message: string,
    backgroundColor = 'blue',
    textColor = 'white',
  ): void {
    if (environment.env !== 'prod') {
      // eslint-disable-next-line no-console
      console.log(
        `%c${message}`,
        `background-color: ${backgroundColor} ; color: ${textColor} ; font-weight: bold ; padding: 8px ;`,
      );
    }
  }
}
